/* eslint-disable no-unused-vars */
export enum LevelName {
    TINY = `tiny`,
    SMALL = `small`,
    MEDIUM = `medium`,
    BIG_WIN_1 = `bigWin1`,
    BIG_WIN_2 = `bigWin2`,
    BIG_WIN_3 = `bigWin3`,
    BIG_WIN_4 = `bigWin4`,
    BIG_WIN_5 = `bigWin5`,
    MAX_CAP = `maxCap`,
    LARGE = `large`,
}

export enum BackgroundNames {
    NORMAL = `normalBackground`,
    FREESPIN = `freespinBackground`,
    SUPER_FREESPIN = `superFreespinBackground`,
}

export enum TimelineLabels {
    SHOW_NEXT_BACKGROUND = `showNextBackground`,
    START_PRESENTATION = `startPresentation`,
    SPECIAL_FEATURE = `specialFeature`,
    START_SYMBOLS_WIN_ANIMATION = `startSymbolsWinAnimation`,
    FINISH_SYMBOLS_WIN_ANIMATION = `finishSymbolsWinAnimation`,
    SHOW_WIN_TEXT = `symbolsWinShowText`,
    // SHOW_TOTAL_WIN_TEXT = `showTotalWinText`,
    TOTAL_WIN_DECORATOR_START = `totalWinDecoratorStart`,
    HIGHLIGHT_TOTAL_WIN_TEXT = `highlightTotalWinText`,
    // HIGHLIGHT_TOTAL_WIN_FINISH = `highlightTotalWinFinish`,
    TOTAL_WIN_DECORATOR_COMPLETE = `totalWinDecoratorComplete`,
    ON_SMALL_WIN_COMPLETE_START = `onSmallWinCompleteStart`,
    ON_SMALL_WIN_COMPLETE_FINISH = `onSmallWinCompleteFinish`,
    ON_BIG_WINS_COMPLETE_START = `onBigWinsCompleteStart`,
    ON_BIG_WINS_COMPLETE_FINISH = `onBigWinsCompleteFinish`,
    ON_MAX_CAP_COMPLETE_START = `onMaxCapCompleteStart`,
    ON_MAX_CAP_COMPLETE_FINISH = `onMaxCapCompleteFinish`,
    WIN_DECORATOR_COMPLETE = `winDecoratorComplete`,
    TEXT_COUNT_COMPLETE = `textCountComplete`,
    XREVOLVER = `xRevolver`,
    SCATTER_DECORATOR_START = `scatterDecoratorStart`,
    SCATTER_DECORATOR_COMPLETE = `scatterDecoratorComplete`,
    SHOW_NEAR_WIN_ANIMATION = `showNearWinAnimation`,
    HIDE_NEAR_WIN_ANIMATION = `hideNearWinAnimation`,
    NEAR_WIN_SCATTER_SYMBOLS_ANIMATION = `nearWinScatterSymbolsAnimation`,
    SCATTER_INITIAL_ANIMATION_COMPLETE = `scatterInitialAnimationComplete`,
    FREESPIN_MULTIPLIER_UPDATE_START = `freespinMultiplierUpdateStart`,
    FREESPIN_MULTIPLIER_UPDATE_COMPLETE = `freespinMultiplierUpdateComplete`,
    SHOW_CONTINUE_BUTTON = `showContinueButton`,
    UNLOCK_REELS = `unlockReels`,
}

export enum WinType {
    TINY = `tiny`,
    SMALL = `small`,
    MEDIUM = `medium`,
    LARGE = `large`,
    BIG = `big`,
    MAX_CAP = `maxCap`,
}
